<mat-card appearance="outlined" class="mat-card-wavesurfer" [ngClass]="{'frameless': frameless}">
  @if (!frameless && canShowToolbar) {
    <mat-card-header>
      <div class="card-header">
          <p class="card_measured_data_title" i18n="@@home.waveCard.title.audioData">
            <span class="material-icons-outlined">headphones</span> 音声データ
          </p>
      </div>
    </mat-card-header>
    <mat-divider></mat-divider>
  }

  <mat-card-content>
    @if (recordLoadingSuccess) {
      <div class="wave-wrapper">
        <div class="wave-column">
          <div class="wave-surface">
            <div class="wave-clip"
                 [style.--av-sync-front-ratio]="avSyncFrontTrimRatio"
                 [style.--av-sync-end-ratio]="avSyncEndTrimRatio"
                 [class.has-av-sync-trim]="avSyncFrontTrimRatio > 0 || avSyncEndTrimRatio > 0">
              <div id="waveDiv" #waveDiv class="wave-div"></div>
            </div>
            <div class="wave-loading-overlay" *ngIf="waveProcessing || waveDownloading || waveLoadingPercent !== null">
              <mat-spinner diameter="40"></mat-spinner>
              <div class="wave-loading-text">
                @if (waveProcessing) {
                  <span i18n="@@home.waveCard.label.processing">データ処理中…</span>
                  <span class="wave-inline-spinner" aria-hidden="true"></span>
                } @else if (waveDownloading) {
                  @if (waveDownloadPercent !== null) { <span i18n="@@home.waveCard.label.downloadingPercent">ダウンロード中… {{ waveDownloadPercent | number:'1.0-0' }}%</span> }
                  @else { <span i18n="@@home.waveCard.label.downloading">ダウンロード中…</span> }
                } @else if (waveLoadingPercent !== null) {
                  {{ waveLoadingPercent | number:'1.0-0' }}%
                }
              </div>
              @if (!waveProcessing && waveDownloadPercent !== null) {
                <mat-progress-bar
                  class="wave-loading-bar"
                  mode="determinate"
                  [value]="waveDownloadPercent">
                </mat-progress-bar>
              }
              @if (!waveProcessing && waveDownloadPercent === null && waveLoadingPercent !== null) {
                <mat-progress-bar
                  class="wave-loading-bar"
                  mode="determinate"
                  [value]="waveLoadingPercent">
                </mat-progress-bar>
              }
            </div>
            <div class="swallow-overlay" [class.is-active]="selectedEvent">
              @if (selectedEvent) {
                <div class="swallow_event_info">
                  <p i18n="@@home.waveCard.label.eventType">種類: {{ getEventTypeLabel(selectedEvent.type) }}</p>
                  <p i18n="@@home.waveCard.label.startTime">開始時刻: {{(selectedEvent.startTime - currentStartOffset).toFixed(2)}}秒</p>
                  <p i18n="@@home.waveCard.label.detectionTime">検出時間: {{(selectedEvent.duration.toFixed(0))/1000}}秒</p>
                </div>
              } @else {
                <div class="swallow-event-placeholder" i18n="@@home.waveCard.hint.hoverForDetails">
                タグにカーソルを合わせると詳細を表示します
                </div>
              }
            </div>
          </div>
          @if (shouldShowTimelineControls) {
            <div class="sound-chart-background"></div>
            <div class="wave-timeline"></div>
          }
        </div>
      </div>

      @if (isVideoMode && !allowVideoModePlayback) {
        <div class="video-sync-hint" i18n="@@home.waveCard.hint.videoSync">動画プレイヤーの再生に同期します</div>
      }

      @if (!frameless) {
        <mat-toolbar class="wavesurfer-button" [ngClass]="{'playing': playing}">
          @if (shouldShowTimelineControls && canShowToolbar) {
            <div class="toolbar-section offset-section">
              @if (showOffsetToggle) {
                <mat-checkbox
                  (change)="offsetToggle.emit($event.checked)"
                  i18n="@@home.waveCard.checkbox.showPreStartAudio">
                  開始直前の音を表示
                </mat-checkbox>
              } @else {
                <span class="toolbar-placeholder"></span>
              }
            </div>

            <div class="toolbar-section center-controls">
              <button mat-icon-button (click)="seek.emit(0)">
                <mat-icon class="player-icon">skip_previous</mat-icon>
              </button>
              <button mat-icon-button (click)="playPauseClicked.emit()" class="sound-button">
                <mat-icon class="player-icon">{{playing ? 'pause_circle_outline' : 'play_circle_outline'}}</mat-icon>
              </button>
              <button mat-icon-button (click)="seek.emit(1)">
                <mat-icon class="player-icon">skip_next</mat-icon>
              </button>
            </div>

            <div class="toolbar-section spacer-section">
              <span class="toolbar-placeholder"></span>
            </div>
          }
        </mat-toolbar>
      }
    @if (frameless && canShowToolbar && (showMiniPlayback || showOffsetToggle)) {
      <div class="mini-playback">
        @if (showMiniPlayback) {
          <button mat-icon-button
            class="mini-playback__button"
            (click)="playPauseClicked.emit()"
            [attr.aria-label]="playing ? playingStopLabel : playingPlayLabel">
            <mat-icon>{{ playing ? 'pause_circle_outline' : 'play_circle_outline' }}</mat-icon>
          </button>
        }
        @if (showOffsetToggle) {
          <mat-checkbox
            class="mini-playback__offset-toggle"
            (change)="offsetToggle.emit($event.checked)"
            i18n="@@home.waveCard.checkbox.showPreStartAudio">
            開始直前の音を表示
          </mat-checkbox>
        }
      </div>
    }
    <div class="zoom-hint" i18n="@@home.waveCard.hint.zoomOperation">ズームはマウスホイール/スクロール操作で行えます</div>
  } @else {
    <div class="wave-error-container">
      <div class="wave-error">
        <mat-icon class="wave-error-icon">error_outline</mat-icon>
        <div class="wave-error-text">
          {{ waveErrorMessage || defaultWaveErrorMessage }}
        </div>
      </div>
    </div>
  }
  </mat-card-content>
</mat-card>
